module.exports = __webpack_public_path__ + "static/assets/2f5a3cc18249997b8da514cf4249b007.svg";